/** Title screen, the settings screen and the shared screen chrome. */
export const menu = {
  'menu.kicker': 'General Staff · Operations',
  'menu.tagline1': 'Every order takes time.',
  'menu.tagline2': 'Every report is already old.',
  'menu.aria': 'Main menu',
  'menu.sp.label': 'Single Player',
  'menu.sp.desc': 'Command against the machine. Pause whenever you must.',
  'menu.scenarios.label': 'Scenarios',
  'menu.scenarios.desc': 'Five situations from history, fought out on new ground.',
  'menu.academy.label': 'Kriegsakademie',
  'menu.academy.desc': 'The staff college: short lessons on a quiet front.',
  'menu.mp.label': 'Multiplayer',
  'menu.mp.desc': 'Up to six generals. Rooms by five-letter code.',
  'menu.archive.label': 'Film Archive',
  'menu.archive.desc': 'Wars on record: load a saved film and watch it again.',
  'menu.manual.label': 'Field Manual',
  'menu.manual.desc': 'Couriers, fog, the Kessel — how war is waged here.',
  'menu.settings.label': 'Settings',
  'menu.settings.desc': 'Sound, scale, language, unit counters and the map table.',
  'menu.net.label': 'SIGNALS NET',
  'menu.net.online': 'CONNECTED',
  'menu.net.connecting': 'ESTABLISHING',
  'menu.net.offline': 'STANDING BY',
  'menu.build': 'STAFF TERMINAL M.24 · BUILD 0.1',
  'menu.quote.stamp': 'Vom Kriege',
  'menu.quote.text': '“Everything in war is very simple, but the simplest thing is difficult.”',
  'menu.quote.by': 'Carl von Clausewitz, 1832',
  'menu.offer.head': 'TELEGRAM · STAFF COLLEGE',
  'menu.offer.urgent': 'URGENT',
  'menu.offer.title': 'New to the staff?',
  'menu.offer.text':
    'Take the Kriegsakademie before your first command STOP Couriers, fog and the Kessel in a quarter of an hour STOP',
  'menu.offer.enrol': 'Enrol',
  'menu.offer.notNow': 'Not now',
  'menu.offer.stamp': 'Invitation',
  'menu.lang.aria': 'Interface language',

  // ---- screen chrome
  'frame.logo': 'FRICTION',

  // ---- settings
  'settings.kicker': 'Staff terminal',
  'settings.title': 'Settings',
  'settings.language': 'Language',
  'settings.language.label': 'Interface language',
  'settings.language.hint': 'Menus, reports, the teletype and the Kriegsakademie. Switches at once.',
  'settings.sound': 'Sound',
  'settings.master': 'Master volume · {value}',
  'settings.muted': 'muted',
  'settings.master.hint': 'Sound starts after your first click — browsers do not allow it earlier.',
  'settings.master.aria': 'Master volume',
  'settings.ambience': 'Ambience · {value}',
  'settings.ambience.hint':
    'Room tone and wind, distant guns that follow the battles in view, the dawn bell.',
  'settings.ambience.aria': 'Ambience volume',
  'settings.effects': 'Effects · {value}',
  'settings.effects.hint': 'Teletype, stamps, and the signals traffic: morse, field telephone, radio static.',
  'settings.effects.aria': 'Effects volume',
  'settings.mute': 'Mute all sound',
  'settings.mute.hint': 'Silences everything; the audio engine idles.',
  'settings.display': 'Display',
  'settings.scale': 'Interface scale · {value}',
  'settings.scale.hint': 'On top of automatic scaling for your screen size.',
  'settings.scale.aria': 'Interface scale',
  'settings.motion': 'Reduced motion',
  'settings.motion.hint':
    'Disable sliding, stamping and typing animations; keeps the ambience still and the guns soft.',
  'settings.newspaper': 'Morning newspaper',
  'settings.newspaper.hint':
    'At 06:00 each day the national paper reports what happened since the last edition.',
  'settings.mapTable': 'Map table',
  'settings.edge': 'Edge scrolling',
  'settings.edge.hint': 'Pan the map when the pointer touches the window edge.',
  'settings.grid': 'Hex grid',
  'settings.grid.hint': 'Draw the hex grid over the map.',
  'settings.counters': 'Unit counters',
  'settings.counters.hint': 'How divisions are drawn on the map and in every report. Switches at once.',
  'settings.counters.illustrated': 'Illustrated',
  'settings.counters.illustrated.desc': 'Riflemen, lorries, tanks, guns and horsemen on cardboard counters.',
  'settings.counters.nato': 'NATO symbols',
  'settings.counters.nato.desc':
    'The staff officer’s signs: a cross for infantry, an oval for armour, a dot for guns.',
  'settings.restore': 'Restore defaults',
} as const;
